"use client";

import type { Transition } from "framer-motion";

export const dragShadows = {
  dragged: "0 10px 28px rgba(15, 23, 42, 0.24)",
  idle: "0 0 0 0 rgba(0,0,0,0)",
};

export const dragTransition = {
  type: "spring",
  stiffness: 320,
  damping: 26,
} satisfies Transition;

export const headerSpring = {
  type: "spring",
  stiffness: 260,
  damping: 24,
} satisfies Transition;

export const controlsSpring = {
  type: "spring",
  stiffness: 420,
  damping: 32,
} satisfies Transition;
